/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAnalyticsTrafficPerPostResponse } from '../../models/get-analytics-traffic-per-post-response';

export interface GetAnalyticsTrafficPerPost$Params {
}

export function getAnalyticsTrafficPerPost(http: HttpClient, rootUrl: string, params?: GetAnalyticsTrafficPerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAnalyticsTrafficPerPostResponse>> {
  const rb = new RequestBuilder(rootUrl, getAnalyticsTrafficPerPost.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAnalyticsTrafficPerPostResponse>;
    })
  );
}

getAnalyticsTrafficPerPost.PATH = '/api/user/analytics/traffic-per-post';
